define( 'views/fieldRepeaterLayout',[ 'views/fieldRepeaterSetCollection' ], function( repeaterSetCollection ) {

    var view = Marionette.LayoutView.extend({
        tagName: 'div',
        template: '#tmpl-nf-field-repeater',

        regions: {
            sets: '.nf-repeater-fieldsets',
        },

        initialize: function() {

            this.collection = this.model.get( 'sets' );

			this.listenTo( nfRadio.channel('field-repeater'), 'rerender:fieldsets', this.render );

			this.listenTo( nfRadio.channel('field-repeater'), 'fieldset:added', this.showAddedFieldset );

        },

        onRender: function() { 
            this.sets.show( new repeaterSetCollection( { collection: this.collection } ) );
        },

		templateHelpers: function() {
			return {
				maybeFilterHTML: function()  {
					return typeof nfFrontEnd.filter_esc_status !== "undefined" ? nfFrontEnd.filter_esc_status : "false";
				},
                renderDescText: function() {
					if ( 'undefined' == typeof this.desc_text ) {
						return '';
					}

					// Creates an element so we can check to see if the text is empty.
					var text = document.createElement( 'p' );
					text.innerHTML = this.desc_text;
					if( 0 == String(text.innerText).trim().length ) return '';

                    var check, checkText;
					checkText = document.createTextNode( this.desc_text );
					check = document.createElement( 'p' );
					check.appendChild( checkText );
					if ( 0 != String(jQuery( check ).text()).trim().length ) {
						var descriptionText, fieldDescription;
                        descriptionText  = document.createRange().createContextualFragment( this.desc_text );
                        fieldDescription  = document.createElement( 'div' );
						fieldDescription.classList.add( 'nf-field-description' );
						fieldDescription.appendChild( descriptionText );
						return fieldDescription.outerHTML;
					} else {
						return '';
					}
				},
			}
		},

        events: {
            'click .nf-add-fieldset': 'addSet'
        },

        addSet: function() {
            nfRadio.channel( 'field-repeater' ).trigger( 'add:fieldset', this.model.id );   
        },

        /**
         * Bring a fieldset that was just added into view.
         *
         * Adding a fieldset re-renders the whole repeater, which leaves the browser
         * free to settle anywhere on the page - including well away from the fieldset
         * the person just asked for. The page is left alone when the new fieldset is
         * already fully on screen, the move is instant rather than animated, and focus
         * is deliberately not taken from the person.
         *
         * @see https://github.com/Saturday-Drive/ninja-forms/issues/7549
         */
        showAddedFieldset: function( repeaterFieldModel ) {
            if( ! repeaterFieldModel || repeaterFieldModel.id !== this.model.id ) return;

            var fieldsets = this.el.querySelectorAll( '.nf-repeater-fieldsets fieldset' );
            var addedFieldset = fieldsets[ fieldsets.length - 1 ];

            if( ! addedFieldset ) return;

            var position = addedFieldset.getBoundingClientRect();
            var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            if( position.top >= 0 && position.bottom <= viewportHeight ) return;

            try {
                addedFieldset.scrollIntoView( { block: 'start', behavior: 'instant' } );
            } catch( error ) {
                // Browsers without the options form of scrollIntoView.
                addedFieldset.scrollIntoView( true );
            }
        },

        beforeSubmit: function() {
			this.collection.beforeSubmit( this.model.get( 'sets' ) );
		}
        

    });

    return view;
} );
